import React from 'react';
import './SearchExportBar.css';

export interface SearchExportBarProps {
  onExport: () => void | Promise<void>;
  disabled?: boolean;
  loading?: boolean;
  title?: string;
  className?: string;
}

const SearchExportBar: React.FC<SearchExportBarProps> = ({
  onExport,
  disabled = false,
  loading = false,
  title = 'Export search results as CSV',
  className = ''
}) => {
  const handleClick = async () => {
    if (disabled || loading) return;
    await onExport();
  };

  return (
    <button
      type="button"
      className={`search-export-bar-button ${className}`.trim()}
      onClick={handleClick}
      disabled={disabled || loading}
      title={title}
      aria-label={title}
    >
      {loading ? (
        <span className="search-export-bar-spinner" aria-hidden="true">⋯</span>
      ) : (
        <svg
          className="search-export-bar-icon"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="7 10 12 15 17 10" />
          <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
      )}
    </button>
  );
};

export default SearchExportBar;
